import { render, staticRenderFns } from "./member-config.vue?vue&type=template&id=4afa7e3c"
import script from "./member-config.vue?vue&type=script&lang=js"
export * from "./member-config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports